import type { CSSStyle } from '~/types'
import { hyphenate } from '@vue/shared'

export function cssStyle2styleText(cssStyle: CSSStyle): string {
  let cssStyleText = ''
  for (const property in cssStyle) {
    cssStyleText += `${hyphenate(property)}: ${cssStyle[property as keyof typeof cssStyle]};`
  }
  return cssStyleText
}
/**
 * Get DOM width for a given text
 */
export function getTextElementWidth(text: string): number {
  const element = document.createElement('span')
  element.innerHTML = text
  document.body.appendChild(element)
  const dimensions = element.getBoundingClientRect()
  document.body.removeChild(element)
  return dimensions.width
}

export function scrollContainerToElement(
  container?: HTMLElement | undefined,
  element?: HTMLElement | undefined,
  options?: ScrollToOptions,
) {
  if (container && element) {
    const containerRect = container.getBoundingClientRect()
    const sectionRect = element.getBoundingClientRect()

    // Calculate the position to scroll to
    const scrollTop = container.scrollTop + sectionRect.top - containerRect.top

    container.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
      ...options,
    })
  }
}
